
import { PublicationsDiscussingModel } from '../models/PublicationsDiscussingModel.js';
import { PublicationsDiscussingView } from '../views/PublicationsDiscussingView.js';

export class PublicationsDiscussingController {
    constructor() {

        this.model = new PublicationsDiscussingModel();
        this.view = new PublicationsDiscussingView();

        this.model.subscribe(state => this.view.render(state));
    }
}